import { render } from "./CertFirePending.vue?vue&type=template&id=7649011b"
import script from "./CertFirePending.vue?vue&type=script&lang=js"
export * from "./CertFirePending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__